module.exports = __webpack_public_path__ + "static/media/Piercing-nose-highnostril.7d548ea7.png";